/**
 * @generated SignedSource<<e236d7f4d1e9dfd98c28a450f77a2f68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LandingPageLoginMutation$variables = {
  instance: string;
};
export type LandingPageLoginMutation$data = {
  readonly login_with: {
    readonly error: string | null;
    readonly url: string | null;
  };
};
export type LandingPageLoginMutation = {
  response: LandingPageLoginMutation$data;
  variables: LandingPageLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instance"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "instance",
        "variableName": "instance"
      }
    ],
    "concreteType": "LoginWithPayload",
    "kind": "LinkedField",
    "name": "login_with",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LandingPageLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LandingPageLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6d72cbf2e04d8321a1f58724e7a5355e",
    "id": null,
    "metadata": {},
    "name": "LandingPageLoginMutation",
    "operationKind": "mutation",
    "text": "mutation LandingPageLoginMutation(\n  $instance: String!\n) {\n  login_with(instance: $instance) {\n    url\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a21cb82982d1592ca35d27fee5152bb";

export default node;
